export default __webpack_public_path__ + "static/media/ladiesnight.60fc7033.png";